import { Alert, Button, Input, Modal } from "reactstrap";

import { Module } from "../../../../types/TenantInterfaces";
import SupportalAPI from "../../../../api/api/SupportalAPI";
import { useState } from "react";
import { newToastEvent } from "../../../../utils/ToastUtil";
import { getErrorMessage } from "../../../../utils/GeneralUtils";
import StrUtils from "../../../../utils/StrUtils";
import { AppConfirm } from "../../../../utils/PopupUtil";

interface Props {
  open: boolean;
  onClose: () => void;
  module: Module;
  tenantID: string;
  type?: "Module" | "Field";
  fieldAPIName?: string;
}

export default function ChangeAPINameModal({
  open,
  onClose,
  module,
  tenantID,
  type = "Module",
  fieldAPIName = "",
}: Props) {
  const [error, setError] = useState("");
  const [newAPIName, setNewAPIName] = useState("");

  return (
    <Modal isOpen={open} toggle={handleClose} className="modal-dialog-centered">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          Change {type} API Name
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body py-0">
        <Input
          placeholder={type === "Module" ? module.APIName : fieldAPIName}
          onChange={(e) => setNewAPIName(StrUtils.cleanAPIName(e.target.value))}
          value={newAPIName}
        />
        {error && (
          <Alert className="mt-2 p-2" color="danger">
            {error}
          </Alert>
        )}
        <div className="d-flex justify-content-end py-4">
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            color="primary"
            onClick={changeModAPIName}
            disabled={!newAPIName}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );

  function handleClose() {
    onClose();
    setNewAPIName("");
    setError("");
  }

  async function changeModAPIName() {
    setError("");

    if (type === "Field" && !fieldAPIName) return;

    const result = await AppConfirm({
      title: "Are you sure?",
      html: `
          Are you sure you want to perform this operation?
          <br /><br />
          This feature is typically used for Global App issues. It is an expensive operation and should be used very
          sparingly. 
          <br /><br />  
          We recommend you backup your cloud before continuing.
        `,
      confirmButtonColor: "var(--danger)",
      confirmButtonText: "Continue",
    });

    if (!result.isConfirmed) return;

    const processName =
      type === "Module" ? "ChangeAPINameProcess" : "RenameAPINameProcess";

    try {
      if (type === "Module") {
        await SupportalAPI.changeModuleApiName(
          tenantID,
          module?.APIName,
          newAPIName
        );
      } else {
        await SupportalAPI.renameFieldAPIName(
          tenantID,
          module?.APIName,
          fieldAPIName,
          newAPIName
        );
      }

      handleClose();

      newToastEvent(
        "success",
        "Successfully started the API name change process. This will take a few minutes."
      );

      newToastEvent(
        "success",
        "Change API name process is currently running... Please wait",
        `${processName}-${tenantID}-${
          type === "Module" ? module?.APIName : fieldAPIName
        }-${newAPIName}`,
        {
          loading: true,
          autoClose: false,
        }
      );
    } catch (err) {
      setError(getErrorMessage(err));
    }
  }
}
